import ComponentBase from "../../public/component/component_base";
import AppData from "../../public/const/app_data";
import Utility from "../../../utility/utility";
import SpriteFrameHolder from "../../public/ui/spriteFrameHolder";
import GameUtil from "../../../utility/game_util";


const {ccclass, property} = cc._decorator;


@ccclass
export default class ClubHallTableInfo extends ComponentBase {

    @property(cc.Label)
    playerNumLabel : cc.Label = null

    @property(cc.Label)
    gameNameLabel : cc.Label = null;

    @property(cc.Label)
    allowNum : cc.Label = null;

    private readonly nameMap = {
        "CLUB_QZNN":"สู้วัว",
        "CLUB_LHD":"เสือมังกร",
        "CLUB_DZPK":"เท็กซัส",
        "CLUB_HJK":"แบล็คแจ็ค",
        "CLUB_BP":"ไพ่แคง",
        "CLUB_BPZD":"ไพ่แคงห้องระเบิด",
        "CLUB_Q2":"ดัมมี่",
        "CLUB_JK":" ป๊อกเด้ง",
        "CLUB_JD":"เก้าเก",
        "CLUB_BJL":"บาคาร่า",
        "CLUB_YXX":"นำเต้าปูปลา",
        "CLUB_TB":"ไฮโล",
        "CLUB_CP":"หวย",
        "CLUB_SLOT":"สล็อต",
    };

    
    refresh( curNum : number ,gameName : string,pub_AllowNum?: number ){            

        this.node.active = gameName != "CLUB_SLOT";

        this.playerNumLabel.string = "";
        this.gameNameLabel.string = "";
        
        this.allowNum.string = pub_AllowNum ? GameUtil.currencyFormat(pub_AllowNum).toString() : "0";

        return;

        this.node.color = cc.Color.WHITE;

        this.node.active = gameName != "CLUB_SLOT";

        this.node.children.forEach((child)=>{
            child.active = true;
        })

        let name = this.nameMap[gameName]
        this.gameNameLabel.string = name;
        let size = Utility.getLabelSize(this.gameNameLabel.string,this.gameNameLabel);    

        this.gameNameLabel.node.parent.width = size.width + 20;

        switch(gameName){
            case "CLUB_YXX"://鱼虾蟹
            case "CLUB_TB"://骰宝 
                this.playerNumLabel.string = curNum > 8? curNum.toString() + "+" : curNum.toString();
                break;                                    
            case "CLUB_JD"://九点
            case "CLUB_DZPK"://德州扑克
                this.playerNumLabel.string = curNum.toString() + "/7";
                break;
            case "CLUB_CP"://彩票  
            case "CLUB_LHD": //龙虎
            case "CLUB_BJL": //百家乐
                this.playerNumLabel.string = curNum > 7?  curNum.toString() + "+" : curNum.toString();
                break;
            case "CLUB_BP"://比牌
            case "CLUB_BPZD":
            case "CLUB_HJK"://21点            
                this.playerNumLabel.string = curNum.toString() + "/5";
                break;
            case "CLUB_QZNN"://牛牛   
            case "CLUB_Q2"://Q2       
                this.playerNumLabel.string = curNum.toString() + "/4";
                break;
            case "CLUB_JK"://9K
                this.playerNumLabel.string = curNum.toString() + "/8";
                break;            
                
        }            
        
    }


}